import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { normalizeProfileForState } from './normalizeProfileForState'

const defaultAvatar =
    'https://minecards.app/media/legacy/taglife-images/avatars/0.png'
const defaultBackground =
    'https://minecards.app/media/legacy/taglife-images/backgrounds/0.png'

const legacyUpgrade = {
    telegram: null,
    limitationCount: 15,
    limitationTime: null,
    isPremium: false,
}

export const loadFirebaseProfile = async (user, now = () => new Date()) => {
    if (!user?.uid) {
        throw new TypeError('Firebase user is required')
    }

    const firestore = await loadLegacyFirestore()
    const profileRef = firestore.doc(firestore.db, 'Auth', user.uid)
    const profileSnapshot = await firestore.getDoc(profileRef)
    if (profileSnapshot.exists()) {
        return loadExistingProfile(
            firestore,
            profileRef,
            profileSnapshot.data(),
            now
        )
    }

    return createProfile(firestore, profileRef, now)
}

const loadExistingProfile = async (firestore, profileRef, data, now) => {
    const lastAuth = now()
    const patch = { 'authTime.lastAuth': lastAuth }
    let profile

    if (typeof data.limitationCount === 'undefined') {
        Object.assign(patch, legacyUpgrade)
        profile = { ...data, ...legacyUpgrade }
    } else {
        profile = {
            ...data,
            authTime: {
                ...data.authTime,
                firstAuth: legacyTimestampNumber(data.authTime?.firstAuth),
                lastAuth: legacyTimestampNumber(data.authTime?.lastAuth),
            },
        }
    }

    const normalizedProfile = normalizeProfileForState(profile, +lastAuth)
    if (
        Number.isFinite(profile.limitationTime) &&
        (normalizedProfile.limitationCount !== profile.limitationCount ||
            normalizedProfile.limitationTime !== profile.limitationTime)
    ) {
        patch.limitationCount = normalizedProfile.limitationCount
        patch.limitationTime = normalizedProfile.limitationTime
    }

    await updateExistingProfile(firestore, profileRef, patch)
    return normalizedProfile
}

const updateExistingProfile = async (firestore, profileRef, patch) => {
    try {
        await firestore.updateDoc(profileRef, patch)
    } catch (error) {
        console.error('Firebase profile refresh failed', error)
    }
}

const createProfile = (firestore, profileRef, now) =>
    firestore.runTransaction(firestore.db, async (transaction) => {
        const concurrentProfile = await transaction.get(profileRef)
        if (concurrentProfile.exists()) {
            return concurrentProfile.data()
        }

        const counterRef = firestore.doc(firestore.db, 'CounterId', 'counter')
        const counterSnapshot = await transaction.get(counterRef)
        const counter = counterSnapshot.data()?.counter
        if (!Number.isSafeInteger(counter) || counter <= 0) {
            throw new Error('Firebase profile counter is invalid')
        }

        const firstAuth = now()
        const profile = {
            id: counter,
            nickname: null,
            name: 'Мечтатель',
            avatar: defaultAvatar,
            friends: [],
            descr: null,
            background: defaultBackground,
            authTime: { firstAuth, lastAuth: firstAuth },
            acceptedMoments: [],
            wantedMoments: [],
            rejectedMoments: [],
            pinnedMoments: [],
            telegram: null,
            limitationCount: 15,
            limitationTime: null,
            isPremium: false,
        }

        transaction.update(counterRef, { counter: counter + 1 })
        transaction.set(profileRef, profile)
        return profile
    })

const legacyTimestampNumber = (value) => {
    if (value && Number.isFinite(value.seconds)) {
        return +new Date(value.seconds)
    }
    return value
}
